import React, { Component } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import moment from "moment";

import MuiPickersUtilsProvider from "@material-ui/pickers/MuiPickersUtilsProvider";
import MomentUtils from "@date-io/moment";

import { MuiThemeProvider } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { withStyles } from "@material-ui/core/styles";
import { EtgsContextProvider } from "../common/etgs-context";
import { emitter } from "../common/NotificationService";
import styles from "./styles";
import etgsTheme from "../assets/jss-component/theme/etgsTheme";

import userService from "../user/UserService";
import Login from "../user/Login";
import Wrapper from "../layout/wrapper/Wrapper";
import Notifications from "../common/Notifications";
import CommonDialog from "../components/CommonDialog";

import NavContent from "./side-nav/NavContent";
import { getLimitDates, getOffsetDate } from "../common/commonDatesService";
import useAutoLogout from "../useAutoLogout";
import { withRouter } from 'react-router-dom';
import BlankPage from "../components/BlankPage";

moment.updateLocale(moment.locale(), { invalidDate: "" });

const AutoLogoutHandler = withRouter((props) => {
    useAutoLogout(props);
    return null;
});

class Frame extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: true,
            user: {
                name: "",
                lastName: "",
                menu: {
                    submenu: []
                },
                passwordStatus: "",
                daysToPasswordExpiration: "",
                passwordExpires: false,
            },
            auth: true,
            anchor: "left",
            showDialog: false,
            showAvisoDialog: false,
            offsetDate: undefined,
            limitDates: undefined,
            loginErrorMsg: [],
            loginAvisoMsg: [
                "RECOMENDAMOS UTILIZAR LA OPCION DEL BOTON 'INICIAR SESION CON MICROSOFT 365'",
                <br />,
                "DADO QUE LA OPCION 'USUARIO Y CONTRASEÑA' DEJARA DE ESTAR DISPONIBLE",
                <br />,
                <br />,
                "CUALQUIER DUDA COMUNICARSE CON itsoporte@tgs.com.ar",
                <br />
            ]
        };
        this.getUser();
    }

    getUser = () => {
        userService.getUser().then(this.setUser);
    };

    handleChangeAnchor = event => {
        this.setState({
            anchor: event.target.value
        });
    };

    toggleDrawer = () => {
        this.setState(prev => ({ open: !prev.open }));
    };

    setUser = user => {
        this.setState({ user });
        this.setOffsetDate();
        this.setLimitDates();
    };

    handleLoginErrorMsg = error => {
        this.setState({
            loginErrorMsg: [error]
        });
    };

    setOffsetDate = (newOffset) => {
        if (newOffset !== undefined) {
            this.setState({
                offsetDate: {
                    offset: newOffset,
                    fechaHoraModificada: newOffset !== 0
                }
            });
            return;
        }
        getOffsetDate().then(resp => {
            this.setState({
                offsetDate: {
                    offset: resp.data.offset,
                    fechaHoraModificada: resp.data.offset !== 0
                }
            });
        });
    };

    setLimitDates = () => {
        getLimitDates()
            .then(({ data }) => this.setState({ limitDates: { ...data } }));
    };

    render() {
        const { classes } = this.props;
        const { open, anchor } = this.state;

        const loginErrorMsg = [
            "El usuario y/o contraseña ingresados son incorrectos. ",
            <br key={1} />,
            <br key={2} />,
            "Por favor, verifique los datos e intente nuevamente.",
            <br key={3} />,
            <br key={4} />,
            "Si necesita solicitar que la clave sea modificada debe enviar un mail a admseg@tgs.com.ar"
        ];

        const contextValue = {
            ...this.state.user,
            ...this.state.offsetDate,
            setOffsetDate: this.setOffsetDate,
            ...this.state.limitDates
        };

        return (
            <EtgsContextProvider value={contextValue}>
                <Router basename={process.env.REACT_APP_BASE_URL}>
                    <MuiThemeProvider theme={etgsTheme}>
                        <MuiPickersUtilsProvider utils={MomentUtils}>
                            <CssBaseline />
                            <div className={classes.root}>
                                <Switch>
                                    <Route
                                        path="/login"
                                        render={props => (
                                            <Login
                                                loginSuccess={(user) => {
                                                    this.setState({
                                                        showAvisoDialog: true
                                                    });
                                                    this.setUser(user);
                                                }}
                                                {...props}
                                                showDialog={state =>
                                                    this.setState({
                                                        showDialog: state
                                                    })
                                                }
                                                loginErrorMsg={state =>
                                                    this.setState({
                                                        loginErrorMsg: state
                                                    })
                                                }
                                            />
                                        )}
                                    />
                                    <Route path="/blank">
                                        <BlankPage />
                                    </Route>
                                    <Route path="/">

                                        <div className={classes.appFrame}>
                                <AutoLogoutHandler />
                                            <NavContent
                                                user={this.state.user}
                                                anchor={anchor}
                                                toggleDrawer={this.toggleDrawer}
                                                handleChangeAnchor={this.handleChangeAnchor}
                                                classes={classes}
                                            />

                                            <Wrapper
                                                open={open}
                                                toggle={this.toggleDrawer}
                                                anchor={anchor}
                                            />
                                        </div>
                                    </Route>
                                </Switch>
                            </div>

                            <Notifications notifier={emitter} />
                            {this.state.loginErrorMsg.length > 0 &&
                                <CommonDialog
                                    open={this.state.showDialog}
                                    disableBackdropClick
                                    title="ATENCIÓN"
                                    backgroundTitle={"rgb(241, 206, 47)"}
                                    noCancelar
                                    maxWidth="md"
                                    contentText={this.state.loginErrorMsg}
                                    aceptarText="Intentar nuevamente"
                                    onClickAceptar={() =>
                                        this.setState({
                                            showDialog: false
                                        })
                                    }
                                    onClose={() =>
                                        this.setState({
                                            showDialog: false
                                        })
                                    }
                                />
                            }
                        </MuiPickersUtilsProvider>
                    </MuiThemeProvider>
                </Router>
            </EtgsContextProvider>

        );
    }
}

export default withStyles(styles, { withTheme: true })(Frame);